import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EmployeeUser } from '../model/employee';

@Injectable({
  providedIn: 'root'
})
export class SupportApiService {

  private baseUrl = `${environment.supportApiUrl}`;
  private headers = {
    headers: {      
      "accept": "*/*"
    }
  };

  constructor(
    private httpClient: HttpClient,
    private translate: TranslateService,
    private store: Store<{}>) {

  }

  getForRestaurant(restaurantId: number | string): Observable<EmployeeUser[]> {
    restaurantId = restaurantId.toString();
    return this.httpClient.get<EmployeeUser[]>(`${this.baseUrl}/Pocket/EmployeeGetForRestaurant?id=${restaurantId}`, this.headers).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  createEmployee(employee: EmployeeUser): Observable<EmployeeUser[]> {
    return this.httpClient.post<EmployeeUser[]>(`${this.baseUrl}/Pocket/EmployeeCreate`, employee, this.headers).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  editEmployee(employee: EmployeeUser): Observable<EmployeeUser[]> {
    return this.httpClient.post<EmployeeUser[]>(`${this.baseUrl}/Pocket/EmployeeUpdate`, employee, this.headers).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  deleteEmployee(id: string): Observable<EmployeeUser[]> {
    return this.httpClient.get<EmployeeUser[]>(`${this.baseUrl}/Pocket/EmployeeDelete?id=${id}`, this.headers).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  invalidateSession(userId: string) {
    return this.httpClient.delete<EmployeeUser[]>(`${this.baseUrl}/Pocket/SessionDeletebyEmployeeId?employeeId=${userId}`, this.headers).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

}
